import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import CampusOverview from './CampusOverview';
import AmbassadorOverview from './AmbassadorOverview';
import AmbassadorDetail from './AmbassadorDetail';
import ReferralPaymentRequests from './ReferralPaymentRequests';

const CampusLayout = () => {
  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar />
      </div>
      <div className='main-content' style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
        <Routes>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<CampusOverview />} />
          <Route path="ambassador-overview" element={<AmbassadorOverview />} />
          <Route path="ambassador-overview/:ambassadorId" element={<AmbassadorDetail />} />
          <Route path="referral-payment-requests" element={<ReferralPaymentRequests />} />
          <Route path="*" element={<Navigate to="overview" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default CampusLayout;

